import { Badge } from '@cloudscape-design/components';
import { ProductStatus } from '@parallel-fluidics/shared/models/products';
import PropTypes from 'prop-types';
import React from 'react';

const ProductStatusColorMap = Object.freeze({
  [ProductStatus.DRAFT]: 'grey',
  [ProductStatus.ACTIVE]: 'green',
  [ProductStatus.RETIRED]: 'red',
});

export default function ProductStatusBadge({ status = null }) {
  return (
    <Badge color={ProductStatusColorMap[status] || 'grey'}>
      {status || 'unknown'}
    </Badge>
  );
}

ProductStatusBadge.propTypes = {
  status: PropTypes.oneOf(Object.values(ProductStatus)),
};
